module.exports = __webpack_public_path__ + "img/btn_order_part_open.986b993b.svg";